<template>
  <div class="email-container">
    <h2>{{ $t("email.title") }}</h2>
    <p class="body">
      {{ $t("email.subTitle") }}
    </p>

    <div class="options">
      <label class="input-checkbox">
        {{ $t("email.company") }}
        <input type="checkbox" v-model="subscribedToCompanyNews" :name="subscribedToCompanyNews" />
        <span class="checkmark"></span>
      </label>

      <label class="input-checkbox">
        {{ $t("email.selectOne") }}
        <a href="https://surfsup.tradeviewforex.com/" target="_blank">{{
          $t("email.selectTwo")
        }}</a>
        {{ $t("email.selectThree") }}
        <input type="checkbox" v-model="subscribedToTradingNews" :name="subscribedToTradingNews" />
        <span class="checkmark"></span>
      </label>
    </div>

    <button class="red-button" @click="update">{{ $t("email.update") }}</button>
    <p class="instructions">
      {{ $t("email.instructions") }}
    </p>
  </div>

  <Modal v-if="showDialog" dialogStyle="login-modal">
    <template #header>
      <h3>{{ $t("email.confirm") }}</h3>
    </template>
    <template #body>
      <div>
        <p>{{ dialogMessage }}</p>
      </div>
    </template>
    <template #footer>
      <div>
        <button @click="closeModal">{{ $t("email.close") }}</button>
      </div>
    </template>
  </Modal>

  <Preloader :showModal="showM"></Preloader>
</template>

<script>
import axios from "axios";
import Preloader from "@/components/Preloader";
import Modal from "@/components/Modal";
import store from "@/store";
import {
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from "@vue/runtime-core";
import { i18n } from "@/plugins/i18n";

export default {
  name: "Email",
  components: {
    Preloader,
    Modal,
  },

  setup() {
    let showM = ref(false);
    let subscribedToCompanyNews = ref(true);
    let subscribedToTradingNews = ref(true);
    let showDialog = ref(false);

    return {
      showM,
      subscribedToCompanyNews,
      subscribedToTradingNews,
      showDialog,
    };
  },

  created() {
    let userInfo = store.state.preferences;

    let sessionStorageOptions = sessionStorage.getItem("userInfo");
    let parsedUserInfoOptions = JSON.parse(sessionStorageOptions);

    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;

    if (!userInfo && !parsedUserInfoOptions) {
      emitter.on("preferencesUpdated", () => {
        userInfo = store.state.preferences;
        console.log(userInfo);
        this.updatePreferences(userInfo);
      });
    }
    if (parsedUserInfoOptions) {
      this.updatePreferences(parsedUserInfoOptions);
    } else {
      this.updatePreferences(userInfo);
    }
  },
  methods: {
    updatePreferences(userInfo) {
      if (!userInfo.hasOwnProperty("subscribedToCompanyNews")) {
        userInfo.subscribedToCompanyNews = this.subscribedToCompanyNews;
      }

      if (!userInfo.hasOwnProperty("subscribedToTradingNews")) {
        userInfo.subscribedToTradingNews = this.subscribedToTradingNews;
      } else {
        this.subscribedToCompanyNews = userInfo.subscribedToCompanyNews;
        this.subscribedToTradingNews = userInfo.subscribedToTradingNews;
      }
    },
    closeModal() {
      this.showDialog = false;
    },
    update() {
      if (this.$store.state.preferences != null) {
        this.showM = true;
        const _headers = {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + this.$store.state.token,
          'X-Api-Key': process.env.VUE_APP_X_API_KEY
        };

        const _url =
          process.env.VUE_APP_CABINET_V2_API_HOST_PREFERENCES +
          "/preferences/user";

        const _body = {
          subscribedToTradingNews:
            this.subscribedToTradingNews === false
              ? false
              : this.subscribedToTradingNews || true,
          subscribedToCompanyNews:
            this.subscribedToCompanyNews === false
              ? false
              : this.subscribedToCompanyNews || true,
        };

        axios({ method: "post", url: _url, data: _body, headers: _headers })
          .then((result) => {
            this.dialogMessage = i18n.global.t("email.submitted");
            this.showDialog = true;
            this.showM = false;

            sessionStorage.setItem("userInfo", JSON.stringify(_body));
            console.log(sessionStorage.getItem("userInfo"));
          })
          .catch((error) => {
            this.dialogMessage = error;
            this.showDialog = true;
            this.showM = false;
          });
      }
    },
  },
};
</script>

<style scoped></style>
